import React from 'react';
import styled from 'styled-components';
import Criticalstock from '../../Charts/Criticalstock';
import PendingAssetReq from '../../Charts/PendingAssetReq';
import WarrntyEx from '../../Charts/WarrantyEx';
import TotalAssets from '../../Charts/TotalAssets';
import TotalUser from '../../Charts/TotalUser';
import TotalOrg from '../../Charts/TotalOrg';

const AllChartContainer = styled.div``
const AllChartWrapper = styled.div`
background-color: #BEDADC;
`
const TopChartConatiner = styled.div`
height: 50vh;
display: flex;
`
const BottomChartContainer = styled.div`
height: calc( 50vh - 50px );
display: flex;
`
const ChartContainer = styled.div`
flex: 1;
`

const StoreManDashboard = () => {
  return (
    <AllChartContainer>
      <AllChartWrapper>
        <TopChartConatiner>
          <ChartContainer>
            <Criticalstock />
          </ChartContainer>
          <ChartContainer>
            <PendingAssetReq />
          </ChartContainer>
          <ChartContainer>
            <WarrntyEx />
          </ChartContainer>
        </TopChartConatiner>
        <BottomChartContainer>
          <ChartContainer>
            <TotalAssets />
          </ChartContainer>
          <ChartContainer>
            <TotalUser />
          </ChartContainer>
          <ChartContainer>
            <TotalOrg />
          </ChartContainer>
        </BottomChartContainer>

      </AllChartWrapper>
    </AllChartContainer>
  )

}
export default StoreManDashboard;
